<template>
  <section class="animals animals-list">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <ul class="categories d-flex" v-if="toggleFilter">
              <li
                  style="background: #EE7372"
              >
                  <!-- TODO метод для сортировки по категориям -->
                  <button class="d-flex" type="button" @click="getFilter()">
                      <span class="categories-icon" style="background-image: url('/assets/images/sos.svg')"></span>
                      SOS ситуации
                  </button>
              </li>
              <li
                  style="background: #F6C143"
              >
                  <!-- TODO метод для сортировки по категориям -->
                  <button class="d-flex" type="button" @click="getProjects()">
                      <span class="categories-icon" style="background-image: url('/assets/images/projects.svg')"></span>
                      Проекты
                  </button>
              </li>
            <li
              v-for="icon in filters"
              :key="icon.name"
              :style="{ background:  icon.color ? icon.color : false}"
            >
                <!-- TODO метод для сортировки по категориям -->
              <button class="d-flex" type="button" @click="getCategory(icon.code)">
                <span v-if="icon.icon" class="categories-icon" :style="'background-image: url(/assets/images/' + icon.icon"></span>
                <span v-else class="categories-icon"></span>
                {{ icon.name }}
              </button>
            </li>
          </ul>
            <div v-else>
                <div class="custom-select-wrapper new-select" @click="selectOpen">
                    <div class="custom-select">
                        <div class="custom-select__trigger">
                          <span>
                              Выберите категорию
                          </span>
                          <div class="arrow"></div>
                        </div>
                        <div class="custom-options">
                            <div class="item" @click="getOption($event,'filter')">
                                <div class="item-label" >
                                    <span class="item-mask" >
                                        <span class="item-icon" style="background: #EE7372">
                                            <img src="/assets/images/sos.svg" alt="">
                                        </span>
                                        SOS ситуации
                                    </span>
                                </div>
                            </div>
                            <div class="item" @click="getOption($event,'project')">
                                <div class="item-label">
                                    <span class="item-mask" >
                                        <span class="item-icon" style="background: #f6c143">
                                            <img src="/assets/images/projects.svg" alt="">
                                        </span>
                                        Проекты
                                    </span>
                                </div>
                            </div>
                            <div class="item" v-for="filter in categoriesMenu" @click="getOption($event,'category', filter.code)">
                                <div class="item-label">
                                    <span class="item-mask" >
                                        <span class="item-icon" :style="{background: filter.color}">
                                            <img :src="'/assets/images/' + filter.icon" alt="">
                                        </span>
                                        {{filter.name}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div>

      </div>

      <div class="row">
        <div class="col-md-12">
            <div class="slider-wrapper">

                <div class="slider-content" v-if="list.length">
                    <swiper ref="swiper" class="swiper" :options="swiperOptionsAnimal" v-if="loaded">

                        <template v-if="list.length">
                            <swiper-slide v-for="(item,index) in list"  :key="index">

                                <div class="animal-info" :class="layoutType" v-if="((layoutType === 'project' && loaded) || (item.project && loaded))">
                                    <!-- TODO прокинуть ссылку иконка на картинке -->
                                    <a :href="'/projects/' + item.project.id" class="image">
                                        <img :src="'/storage' + item.avatar | convertImage('square')" :alt="item.project.name" v-if="item.avatar" />
                                        <span v-else>{{item.project.name}}</span>
                                    </a>
                                    <div class="descr">
                                        <h6 class="d-flex">
                                            <!-- TODO прокинуть ссылку -->
                                            <a :href="'projects/' + item.project.id" class="title">{{item.project.name}}</a>
                                            <!-- TODO прокинуть иконки категории и цвет категории -->
                                            <span class="icon" style="background: #EE7372">
                                  <img src="/assets/images/projects.svg" alt=""/>
                                 </span>
                                        </h6>
                                        <p class="info" v-html="item.project.description"></p>
                                        <div class="rating w-100">
                                            <!-- TODO прокинуть цвет категории -->
                                            <p>{{ (+item.project.donationsProgress).toFixed()}} %</p>
                                            <div class="rating-block progress">
                                                <div class="filled" v-if="(+item.project.donationsProgress).toFixed() < 100"
                                                     :style="{width: (+item.project.donationsProgress).toFixed() < 100 ? (+item.progress).toFixed() + '%' : '',
                                                              background:  '#EE7372'}"></div>
                                                <div class="filled" v-if="(+item.project.donationsProgress).toFixed() >= 100"
                                                     :style="{width: '100%', background: '#91DA66'}"></div>
                                            </div>
                                        </div>
                                        <ul class="d-flex statistics" v-if="(+item.project.donationsProgress).toFixed() < 100">
                                            <li class="help">
                                                <div class="statistics__header">
                                                    <p class="num black">{{(+item['collected_money']).toFixed(2)}} BYN</p>
                                                    <p class="status black">Собрано</p>
                                                </div>
                                                <!-- TODO прокинуть ссылку -->
                                                <a :href="'/projects/' + item.project.id" class="btn">Помочь!</a>
                                            </li>
                                            <li class="mission">
                                                <div class="statistics__header">
                                                    <p class="num silver">{{(+item.project.need_sum).toFixed(2)}} BYN</p>
                                                    <p class="status silver">Цель</p>
                                                </div>
                                                <!-- TODO прокинуть ссылку -->
                                                <a :href="'/projects/' + item.project.id" class="btn btn-light">Подробнее</a>
                                            </li>
                                        </ul>

                                        <ul class="d-flex statistics statistics--done" v-else>
                                            <li class="done">
                                                <span class="sum">
                                                    {{item.project.need_sum}} BYN
                                                </span>
                                                <span class="text">
                                                    Цель достигнута
                                                <img src="/assets/images/icons/done.svg" alt="">
                                            </span>
                                            </li>
                                            <li class="help">
                                                <a :href="'/projects/' + item.project.id" class="btn">Помочь!</a>
                                            </li>
                                            <li class="mission">
                                                <a :href="'/projects/' + item.project.id" class="btn btn-light">Подробнее</a>
                                            </li>
                                        </ul>

                                    </div>
                                </div>

                                <div class="animal-info" :class="layoutType" v-else>
                                    <!-- TODO прокинуть ссылку иконка на картинке -->
                                    <a :href="'/pets/' + item.pet.id" class="image">
                                        <img :src="'/storage' + item.avatar | convertImage('square')" :alt="item.pet.name" v-if="item.avatar" />
                                        <span v-else>{{item.pet.name}}</span>
                                    </a>
                                    <div class="descr d-flex">
                                        <h6 class="d-flex">
                                            <!-- TODO прокинуть ссылку -->
                                            <a :href="'/pets/' + item.pet.id" class="title">{{item.pet.name}}</a>
                                            <!-- TODO прокинуть иконки категории и цвет категории -->
                                            <span class="icon" :style="{background: item.pet.petCategory.color ? item.pet.petCategory.color : '#2E76E4'}">
                                              <img :src="'/assets/images/' + item.pet.petCategory.icon" alt="" v-if="item.pet.petCategory.icon"/>
                                              <img src="/assets/images/sos.svg" alt="" v-else/>
                                            </span>
                                        </h6>
                                        <p class="info" v-html="item.pet.description"></p>
                                        <div class="rating w-100">
                                            <!-- TODO прокинуть цвет категории -->
                                            <p>{{ (+item.pet.donationsProgress).toFixed() }} %</p>
                                            <div class="rating-block progress" >
                                                <div class="filled" v-if="(+item.pet.donationsProgress).toFixed() < 100"
                                                     :style="{width: (+item.pet.donationsProgress).toFixed() < 100 ? (+item.progress).toFixed() + '%' : '',
                                                               background: item.pet.petCategory.color ? item.pet.petCategory.color : '#2E76E4'}"></div>
                                                <div class="filled" v-if="(+item.pet.donationsProgress).toFixed() >= 100"
                                                     :style="{width: '100%', background: '#91DA66'}"></div>
                                            </div>
                                        </div>
                                        <ul class="d-flex statistics" v-if="(+item.pet.donationsProgress).toFixed() < 100">
                                            <li class="help">
                                                <div class="statistics__header">
                                                    <p class="num black">{{(+item['collected_money']).toFixed(2)}} BYN</p>
                                                    <p class="status black">Собрано</p>
                                                </div>
                                                <!-- TODO прокинуть ссылку -->
                                                <a :href="'pets/' + item.pet.id" class="btn">Помочь!</a>
                                            </li>
                                            <li class="mission">
                                                <div class="statistics__header">
                                                    <p class="num silver">{{(+item.pet.need_sum).toFixed(2)}} BYN</p>
                                                    <p class="status silver">Цель</p>
                                                </div>
                                                <!-- TODO прокинуть ссылку -->
                                                <a :href="'pets/' + item.pet.id" class="btn btn-light">Подробнее</a>
                                            </li>
                                        </ul>

                                        <ul class="d-flex statistics statistics--done" v-else>
                                            <li class="done">
                                                <span class="sum">
                                                    {{item.pet.need_sum}} BYN
                                                </span>
                                                <span class="text">
                                                    Цель достигнута
                                                <img src="/assets/images/icons/done.svg" alt="">
                                            </span>
                                            </li>
                                            <li class="help">
                                                <a :href="'/pets/' + item.pet.id" class="btn">Помочь!</a>
                                            </li>
                                            <li class="mission">
                                                <a :href="'/pets/' + item.pet.id" class="btn btn-light">Подробнее</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </swiper-slide>
                        </template>


<!--                        <template v-if="layoutType === 'pet' && list.length">
                            <swiper-slide v-for="(pet,index) in list" :key="index" >

                            </swiper-slide>
                        </template>-->

                    </swiper>
                    <div v-else>
                        <div class="LoaderBalls">
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                        </div>
                    </div>
                </div>
                <div class="slider-wrapper__empty d-flex" v-else>
                    Пусто
                </div>
            </div>

         </div>
          <div class="col-md-12">
              <div class="d-flex justify-content-end mt-5 mb-5 animal-navigation">
                  <div class="slider-navigations" v-if="list.length">
                      <div id="animals-list-prev" class="swiper-button-prev" slot="button-prev"></div>
                      <div id="animals-list-next" class="swiper-button-next" slot="button-next"></div>
                  </div>
                  <a href="/catalog/pets" class="btn">Смотреть все</a>
              </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
export default {

  props:['petslist', 'filters'],

  data: () => ({

    categoriesMenu: [],
    selectedMenu: '',
    swiperOptionsAnimal: {
      slidesPerView: 1,
      slidesPerColumn: 3,
      direction: 'horizontal',
      slidesPerColumnFill: 'row',
      roundLengths: true,
      navigation: {
        nextEl: '#animals-list-next',
        prevEl: '#animals-list-prev',
      },
        breakpoints: {
            320: {
                slidesPerView: 1, // or 'auto'
                slidesPerColumn: 3,
                spaceBetween: 10,
                slidesPerColumnFill: 'column',
            },
            768:{
                slidesPerView: 2,
                slidesPerColumn: 1,
                spaceBetween: 10,
                direction: 'horizontal',
                slidesPerColumnFill: 'row',
            },
            992: {
                slidesPerView: 3,
                slidesPerColumn: 1,
                direction: 'horizontal',
                spaceBetween: 32,
                slidesPerColumnFill: 'row',
            },
        },
    },
    toggleFilter: true,
      loaded: true,
      pets: [],
      appRoutes: null,
      categoryType: 'pet',
      filterUrl: '/pets/list-with-progress'
  }),
  components: {
    Swiper,
    SwiperSlide,
    vSelect,
  },
    created(){
        window.addEventListener('click', this.selectClose)
    },

    destroyed(){
        window.removeEventListener('click', this.selectClose)
    },

    computed:{
        layoutType(){
          return this.categoryType;
        },
        list(){
            return this.pets
        },
    },

    watch:{
      list(){
          this.loaded = false;
          setTimeout(()=>{
              this.loaded = true
          }, 1000)
      }
    },
  methods: {
      selectOpen(){

          let customSelect = document.querySelector('.new-select .custom-select');
          customSelect.classList.toggle('open')

      },
      getOption(e, flag, filter){
          let opt = e.target;

          if (!opt.classList.contains('selected')) {
              if(opt.parentNode.querySelector('.item.selected'))opt.parentNode.querySelector('.item.selected').classList.remove('selected');
              opt.classList.add('selected');
              opt.closest('.custom-select').querySelector('.custom-select__trigger span').innerHTML = opt.querySelector('.item-mask').innerHTML;

              setTimeout(()=>{
                  opt.closest('.custom-select').classList.remove('open')
              }, 300)
          }

          switch (flag){
              case 'filter':
                  this.getFilter();
                  break;
              case 'project':
                  this.getProjects();
                  break;
              case 'category':
                  this.getCategory(filter);
                  break;
          }

      },
    onWindthHandler(width) {
      if (width <= 992) {
        this.toggleFilter = false
      } else {
        this.toggleFilter = true
      }
    },

      selectClose(e){

          if(this.toggleFilter) return;

          let select = document.querySelector('.custom-select');

          if(!select.contains(e.target)){

              select.classList.remove('open')

          }

      },
    getProgress(pet){

        let sum = (+pet['collected_money'] / +pet['need_sum'] * 100).toFixed();

        if(isNaN(sum)) sum = 0;

        return  sum
    },
      getProjects(){
          this.loaded = false;
          let url = 'projects/list-with-progress/support';

          axios.get(url)
              .then(response => {
                  response = response.data;
                  if (response.success) {
                      this.pets = response.data;
                      this.loaded = true
                  } else {
                      alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                  }
              })
              .catch((error) => {

              })
              .then(
              );
          this.categoryType = 'project'
      },
      getFilter(){
        this.loaded = false;
        this.filterUrl = '/pets/list-with-progress?pet_filter_id=4';
        this.categoryType = 'pet';


          axios.get(this.filterUrl)
              .then(response => {
                  response = response.data;
                  if (response.success) {
                      this.pets = response.data;

                      this.loaded = true
                  } else {
                      alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                  }
              })
              .catch((error) => {

              })
              .then(
              );


      },
      getCategory(category) {
          this.loaded =false
          this.filterUrl = `/pets/list-with-progress/${category}`;

          axios.get(this.filterUrl)
              .then(response => {
                  response = response.data;
                  if (response.success) {
                      this.pets = response.data;
                      this.loaded = true

                  } else {
                      alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                  }
              })
              .catch((error) => {

              })
              .then(
              );


          this.categoryType = 'pet'

      },

  },
    mounted() {
        this.categoriesMenu = this.filters;

        if (this.petslist.project) {
            this.pets.push(this.petslist.project);
        }
        if (this.petslist.lessDonatedPet) {
            this.pets.push(this.petslist.lessDonatedPet);
        }
        if (this.petslist.halfDonatedPet) {
            this.pets.push(this.petslist.halfDonatedPet);
        }
        this.pets = this.pets.concat(this.petslist.catalogPets);

        this.onWindthHandler(window.innerWidth);
        window.addEventListener('resize', () => {
            this.onWindthHandler(window.innerWidth);
        })
    },
}
</script>

<style lang="scss">
//@import '~swiper/swiper-bundle.min.css';
@import '~vue-select/src/scss/vue-select.scss';
.select-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: red;
  text-align: center;
  line-height: 24px;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 10px;
}


.custom-select-wrapper {
    position: relative;
    user-select: none;

    width: 300px;
    margin: 15px auto;
}
.custom-select {
    position: relative;
    padding: 0;
    background: transparent;
    height: auto;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    width: 100%;
    margin: 0 auto;
    border: none;


    .profile-filter__item-mask{
        position: relative;
        padding: 0 32px;
        line-height: 40px;
        height: 40px;
        font-size: 12px;

        .profile-filter__item-icon{
            position: absolute;

            left: 15px;
            top: 50%;

            transform: translateY(-50%);
        }

    }



}
.custom-select__trigger {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px 0 32px;
    font-size: 12px;
    font-weight: 300;
    color: #3b3b3b;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #929292;
    z-index: 3;
    .profile-filter__item-icon{
        position: absolute;

        left: 15px;
        top: 50%;

        transform: translateY(-50%);
    }

}
.custom-options {
    position: absolute;
    display: block;
    top: calc(100% - 10px);
    left: 0;
    right: 0;
    padding-top: 10px;
    border: 1px solid #929292;
    border-top: 0;
    background: #fff;
    transition: all 0.5s;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 2;

    .item-label{
        pointer-events: none;
    }
    .custom-select__trigger,
    .item-mask{
        position: relative;
        display: block;
        padding-left: 40px;
        pointer-events: none;
        height: 40px;
        line-height: 40px;
    }
    .custom-select__trigger .item-icon,
    .item-icon{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        bottom: 0;
        top: 0;
        width: 35px;
    }
    .custom-select__trigger .item-icon img,
    .item-icon img{
        width: 18px;
        height: auto;
    }

    .item.selected .item-label{
        color: #fff;
        background: #2E76E4;
    }
}
.custom-select{
    .custom-select__trigger{
        position: relative;
        padding-left: 40px;
        pointer-events: none;
        height: 40px;
        line-height: 40px;
        overflow: hidden;
    }
    .custom-select__trigger .item-icon{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        bottom: 0;
        top: 0;
        width: 35px;
    }
    .custom-select__trigger .item-icon img{
        width: 18px;
        height: auto;
    }
}
.custom-select.open{
    height: auto;
}

.custom-select.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
}
.custom-option {
    position: relative;
    display: block;
    padding: 0 22px 0 22px;
    font-size: 22px;
    font-weight: 300;
    color: #3b3b3b;
    line-height: 60px;
    cursor: pointer;
    transition: all 0.5s;
}
.custom-option:hover {
    cursor: pointer;
    background-color: #b2b2b2;
}
.custom-option.selected {
    color: #ffffff;
    background-color: #305c91;
}

.arrow {
    position: relative;
    height: 10px;
    width: 10px;
}
.arrow::before, .arrow::after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 0.15rem;
    height: 100%;
    transition: all 0.5s;
}
.arrow::before {
    left: -3px;
    transform: rotate(45deg);
    background-color: #394a6d;
}
.arrow::after {
    left: 3px;
    transform: rotate(-45deg);
    background-color: #394a6d;
}
.open .arrow::before {
    left: -3px;
    transform: rotate(-45deg);
}
.open .arrow::after {
    left: 3px;
    transform: rotate(45deg);
}



.slider-wrapper{
    min-height: 500px;
    text-align: center;
    flex-flow: row nowrap;

    .LoaderBalls{
        min-height: 500px;
    }
    &__empty{
        align-items: center;
        justify-content: center;
        font-size: 40px;
        font-weight: bold;
        height: 500px;
    }


    .swiper-slide{
        height: auto;
    }

}
.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}
.slider-wrapper{
    min-height: 500px;
}
.animals {
  background-color: #eff1f3;
  .v-select {
    margin: 20px auto;
    width: 50%;
    .vs__dropdown-toggle {
      border-radius: 20px;
      padding: 4px 15px 8px;
    }
    .vs__open-indicator {
      fill: #000;
    }
  }
  .icon {
    border-radius: 100%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 15px;
    }
  }
  .btn {
    padding: 10px 20px;
    background: #2e76e4;
    border-radius: 45px;
    color: #fff;
    font-family: 'Comfortaa', cursive;
    font-size: 12px;
    border: none;
    cursor: pointer;
    margin-right: 16px;
    transition: 0.3s ease;
    text-transform: capitalize;
    &:hover {
      color: #fff;
      opacity: 0.9;
    }
    &-light {
      padding: 10px 20px;
      background: #eaf1fc;
      border-radius: 45px;
      color: #2e76e4;
      font-family: 'Comfortaa', cursive;
      font-size: 12px;
      border: none;
      cursor: pointer;
      transition: 0.3s ease;
      outline: none;
      &:hover {
        color: #2e76e4;
      }
    }
  }
  .categories {
      padding: 0 14px;
    justify-content: flex-start;
    margin: 40px -7px;
    list-style-type: none;
    li {
        flex-grow: 1;
      border-radius: 30px;
      padding: 7px 20px 0;
        margin-left: 7px;
      opacity: 1;
      transition: opacity 0.6s;
      button {
          text-align: center;
          justify-content: center;
          align-items: center;
        color: #fff;
        font-family: 'Comfortaa', cursive;
        width: 100%;
        height: 100%;
        background: none;
        border: none;
        outline: none;
          font-size: 11px;
        .categories-icon {
            display: inline-block;
          width: 25px;
          height: 25px;
            margin-right: 7px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
        }
        &:hover {
          text-decoration: none;
        }
      }
      &:nth-child(1) {
        background: #ee7372;
          margin-left: 0;
          .categories-icon{
              background-image: url('/assets/images/sos.svg');
          }
      }
      &:nth-child(2) {
        background: #f6c143;
          .categories-icon{
              background-image: url('/assets/images/projects.svg');
          }
      }
      &:nth-child(3) {
        background: #91da66;
          .categories-icon{
              background-image: url('/assets/images/home.svg');
          }
      }
      &:nth-child(4) {
        background: #2e76e4;
          .categories-icon{
              background-image: url('/assets/images/cats.svg');
          }
      }
      &:nth-child(5) {
        background: #6c4dbb;
          .categories-icon{
              background-image: url('/assets/images/dogs.svg');
          }
      }
      &:nth-child(6) {
        background: #9ebae0;
          .categories-icon{
              background-image: url('/assets/images/others.svg');
          }
      }
      &:hover {
        opacity: 0.85;
      }
      &.active {
        opacity: 0.6;
      }
    }
  }
  .animal-info {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      height: 100%;
    border-radius: 5px;
    background: #fff;
    //font-family: 'Comfortaa', cursive;
    .image {
      display: block;
      height: 267px;
      img {
          flex-shrink: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px 5px 0 0;
      }
    }
    .descr {
      padding: 16px;
        flex-grow: 1;
        flex-direction: column;
        flex-wrap: nowrap;
      h6 {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        margin: 16px 0;
        justify-content: space-between;
      }
       .title{
           color: inherit;
           display: -webkit-box;
           -webkit-line-clamp: 2;
           -webkit-box-orient: vertical;
           overflow: hidden;
           height: 42px;
           transition: opacity .2s ease;
           &:hover{
               opacity: .8;
           }

       }
        .icon{
            min-width: 24px;
        }
      .info {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          height: 54px;
          font-size: 12px;
        color: #555555;
      }

      .rating {
        text-align: center;
        margin-bottom: 20px;
        p {
          font-size: 14px;
          color: #555555;
        }
        .rating-block {
          width: 100%;
          height: 5px;
          border-radius: 5px;
          position: relative;
          .filled {
            position: absolute;
            top: 0;
            left: 0;
            width: 54%;
            height: 5px;
            border-radius: 5px;
          }
        }
      }
        .statistics{
            li{
                &+li{
                    .statistics__header{
                        position: relative;


                        &::before{
                            position: absolute;
                            display: block;
                            content: '';
                            background: #ececec;
                            top: 5px;
                            left: 0;
                            width: 1px;
                            height: 57px;
                        }

                    }
                }
            }

            &--done{
                flex-wrap: wrap;
                flex-grow: 1;
                .done{
                    flex-grow: 1;
                    width: 100%;
                    text-align: center;
                    font-weight: normal;
                    font-size: 14px;
                    height: auto;
                    line-height: 1;
                    .sum{
                        display: block;
                        font-weight: bold;
                        font-size: 24px;
                        line-height: 36px;
                        color: #333333;
                    }

                    .text{
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 30px;
                        img {
                            width: 15px;
                            height: auto;
                            margin-left: 7px;
                        }
                    }
                }
            }

        }
        .help,
        .mission{
            .btn{
                margin: 0;
                transition: opacity .2s ease;
                &::before{
                    display: none;
                }

                &:hover{
                    opacity: .8;
                }
            }
        }
      ul {
        list-style: none;
        padding: 0;
        li {
          width: 50%;
          text-align: center;

          p {
            margin: 0;
          }
          .num {
            font-size: 24px;
          }
          .status {
            font-size: 14px;
            margin-bottom: 30px;
          }

            &.help{
                margin-bottom: 0 !important;
            }
        }
      }
    }
  }
  // swiper
  .swiper {
    //&-wrapper {
    //  transition-duration: 0.8s !important;
    //}
    &-button {
      &-next,
      &-prev {
        position: static;
        background: #ffffff;
        border-radius: 20px;
        width: 56px;
        height: 40px;
        outline: none;
        margin: 0 10px;
        &:after {
          color: transparent;
        }
      }
      &-next:after {
        background: url('/assets/images/slide-arw-right.svg') no-repeat;
        background-size: contain;
        background-position: 50% 50%;
      }
      &-prev:after {
        background: url('/assets/images/slide-arw-right.svg') no-repeat;
        background-size: contain;
        background-position: 50% 50%;
        transform: rotate(180deg);
      }
    }
  }
  .slider-navigations {
    display: flex;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    align-items: center;
  }
}
@media only screen and (max-width: 768px) {
  .animals {
    .slider-navigations {
      left: 0;
      transform: translate(0, 0);
      position: static;
      margin-right: auto;
    }
    .animal-info {
      display: flex;
      justify-content: flex-start;
      border-radius: 4px;

      .image {
          flex-shrink: 0;
        width: 200px;
        height: auto;
        img {
          border-radius: 4px;
        }
      }
      .descr {
        width: 100%;
        padding: 15px;
        h6 {
          align-items: center;
          font-size: 15px;
          margin: 0;
        }
        .info {
          display: none;
        }
        ul {
          button {
            display: none;
          }
          li {
            .num {
              font-size: 15px;
            }
            //.status {
            //  display: none;
            //}


          }
        }
      }
    }
  }
    .animals-list .swiper-container{
        height: calc((240px * 3) + 30px);
    }
    .animals-list .swiper-slide{
        height: auto;
        max-height: 240px;
    }

    .animal-navigation{
        margin-top: 10px !important;
    }

    .animals .animal-info{
        flex-direction: row;
    }
    .animals .animal-info .descr .rating{
        margin-bottom: 10px;
    }
    .animals .animal-info .descr ul li .status{
        margin-bottom: 15px;
    }
    .animals .animal-info .descr ul li{
        margin-bottom: 0 !important;
    }
    .animals .animal-info .descr .title{
        height: 37px;
    }

}

@media screen and (max-width: 600px){
    .animals .animal-info .descr ul{
        flex-direction: column;
        align-items: center;
    }

    .animals .animal-info .descr .statistics li + li .statistics__header::before{
        display: none;
    }
    .animals .animal-info .descr ul li{
        width: 100%;
    }
    .animals .animal-info .descr ul li.help{
        margin-bottom: 20px !important;
    }
    .animals .animal-info .descr .statistics  .statistics__header{
        display: none;
    }

    .animals .animal-info .descr .statistics--done .done .sum{
        display: none;
    }
    .animals .animal-info .descr .statistics--done .done .text{
        margin-bottom: 10px;
    }
}
@media only screen and (max-width: 520px) {
  .animals {
    .v-select {
      width: 100%;
    }
    .btn {
      margin-right: 0;
      padding: 10px 15px;
    }
  }
}

@media screen and (max-width: 480px){
    .animals .animal-info .image{
        width: 150px;
    }
    .animals .animal-info .descr ul .mission{
        display: none;
    }
    .animals .animal-info .descr ul .help{
        margin-bottom: 0 !important;
    }

    .animal-navigation{
     flex-direction: column;
        align-items: center;
    }
    .animals .slider-navigations{
        margin-right: unset;
    }
    .animal-navigation .btn{
        margin-top: 15px;
    }

    .animals-list .swiper-container{
        height: calc((205px * 3) + 30px);
    }
    .animals-list .swiper-slide{
        height: auto;
        max-height: 205px;
    }

}

@media only screen and (max-width: 360px) {
  .animals {
    .animal-info {
      //height: 140px;
      .image {
        max-width: 120px;
        height: auto;
      }
    }
  }
}
.silver {
  color: #929292;
}
.bg-silver {
  background: #929292;
}
.bg-green {
  background: #91da66;
}
.black {
  color: #333333;
}
.help {
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
